import { AttributeType } from "../../../clients/Purchaser/Attributes";
import { MenuCheckboxItem } from "../../DesignSystem";
import type { SetAttributeFilter } from "../types";

// The attribute types that can be filtered on whether they hold a value at all.
type SetFilterType = AttributeType.FILE | AttributeType.PHONE | AttributeType.ADDRESS;

const SET_OPTIONS: { label: string; set: boolean }[] = [
    { label: "Is set", set: true },
    { label: "Is not set", set: false },
];

type SetFilterItemsProps = {
    type: SetFilterType;
    attributeId: number;
    // The set/not-set choice already applied, if any.
    currentSet?: boolean;
    setAttributeFilter: SetAttributeFilter;
    // Runs before the filter is written, such as to clear a "contains" search the choice replaces.
    onPick?: () => void;
};

// "Is set" / "Is not set" rows. Clicking the already-selected option clears the filter.
function SetFilterItems({ type, attributeId, currentSet, setAttributeFilter, onPick }: SetFilterItemsProps) {
    const select = (set: boolean) => {
        onPick?.();
        const next = { type, attributeId, set };
        if (currentSet === set) {
            setAttributeFilter(next, true);
        } else {
            setAttributeFilter(next);
        }
    };

    return (
        <>
            {SET_OPTIONS.map(option => (
                <MenuCheckboxItem key={option.label} checked={currentSet === option.set} onChange={() => select(option.set)}>
                    {option.label}
                </MenuCheckboxItem>
            ))}
        </>
    );
}

export default SetFilterItems;
